import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import startCase from 'lodash/startCase';
import classnames from 'classnames'
import cover from './hands.png';
import { Image } from '../../Image';
import { DeleteProject } from '../../DeleteProject';
import loadingImage from '../../../assets/images/loading-image.gif';
import './ProjectCard.css';

export const ProjectCard = ({ color, project, handleGoToProjectView, handleDiscardProject }) => {
  const { drafts, status, project_name, project_picture, updated_at } = project;
  const [open, setOpenPopup] = useState(false);
  const [showDeleteButton, setShowDeleteButton] = useState(false)
  const deadline = getDeadline(project);
  const formattedDeadline = deadline
    ? createFormattedDate(deadline)('MM/DD/YY')
    : 'Pending';
  const timeToDeadline = diffBetweenNowAndDeadline(deadline);
  let lastDraftDate = null;
  if (drafts) {
    const lastDraft = _.last(_.sortBy(drafts, (draft) => draft.name))
    lastDraftDate = createFormattedDate(lastDraft.due_date)('MM/DD/YY');
  } else {
    lastDraftDate = 'Pending';
  }

  return (
    <React.Fragment>
      <div
        className="col-12 col-md-6 col-lg-3 p-0 mb-4 card"
        onMouseOver={(event) => setShowDeleteButton(true)}
        onMouseLeave={(event) => setShowDeleteButton(false)}
      >
        <div
          className="card-img-top card-img-top-bg position-relative cursor-pointer project-picture"
          style={{
            backgroundImage: `url(${project_picture ? loadingImage : cover})`,
            backgroundSize: "contain",
            backgroundColor: project_picture ? 'unset' : color,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '50% 50%',
          }}
          onClick={() => handleGoToProjectView(project)}
        >
          <Image alt="avatar" src={project_picture} />
        </div>
        <div
          className={classnames("delete-project", { "opacity-08": showDeleteButton })}
        >
            <i className="icon icon-clearer text-gray-light t-20" onClick={() => setOpenPopup(!open)}/>
        </div>
        <div className="card-body">
          <div className="row justify-content-between m-0">
            <div
              className="col-12 pb-3 with_border"
              style={{
                minHeight: '29px',
              }}
            >
              <h3 className="t-12 text-gray-light">{`${startCase(
                status,
              )} Project`}</h3>
              <h4 className="t-20 project_name">{project_name}</h4>
            </div>
            <div
              className="col-12 pb-3 last-draft"
              style={{
                minHeight: '29px',
              }}
            >
              <h3 className="t-16 text-gray-light">Last Draft</h3>
              <h3 className="t-16">{lastDraftDate}</h3>
            </div>
            <div
              className="col-12 pb-3 deadline"
              style={{
                minHeight: '29px',
              }}
            >
              <h3 className="t-16 text-gray-light">Deadline</h3>
              <h3 className="t-16 d-flex align-items-baseline">
                {formattedDeadline}
                <p
                  className="t-12"
                  style={{
                    color: '#F45252',
                  }}
                >
                  {timeToDeadline && `${timeToDeadline} left`}
                </p>
              </h3>
            </div>
          </div>
        </div>
      </div>
      <DeleteProject
        open={open}
        setOpenPopup={setOpenPopup}
        project={project}
        handleDiscardProject={handleDiscardProject}
      />
    </React.Fragment>
  );
};

const createFormattedMoment = date => moment(date, 'YYYY-MM-DD');

const createFormattedDate = date => format =>
  createFormattedMoment(date).format(format);

const diffBetweenNowAndDeadline = deadline => {
  if (!deadline) {
    return;
  };

  const deadlineInTime = moment(deadline);
  const timeNow = moment();

  if (deadlineInTime < timeNow) {
    return;
  };

  return moment.duration(deadlineInTime.diff(timeNow)).humanize();
};

const getDeadline = project => {
  const value = project.project_onboarding_infos.filter(
    info => info.question.key == 'deadline',
  );

  return value[0].question_response[0];
};

ProjectCard.propTypes = {
  color: PropTypes.string,
  project: PropTypes.shape({
    drafts: PropTypes.arrayOf(PropTypes.shape({})),
    project_name: PropTypes.string,
    updated_at: PropTypes.string,
    status: PropTypes.string,
    price_selected: PropTypes.number,
    bid_info: PropTypes.shape({
      last_bid_created_at: PropTypes.string,
    }),
    bids: PropTypes.array,
  }),
  handleGoToProjectView: PropTypes.func.isRequired,
  handleDiscardProject: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/DashboardCard/ProjectCard/ProjectCard.js